import React from 'react';
import { Avatar, Typography } from 'antd';
import ReactMarkdown from 'react-markdown';

const { Text } = Typography;

interface AIMessageProps {
  message: string;
  index: number;
}

export const AIMessage: React.FC<AIMessageProps> = ({ message, index }) => (
  <div className="message ai-message" data-message-index={index}>
    <Avatar className="message-avatar">
      <Text className="avatar-text">AI</Text>
    </Avatar>
    <div className="message-content">
      <div className="markdown-content">
        <ReactMarkdown
          components={{
            h1: ({ children }) => <h1>{children}</h1>,
            h2: ({ children }) => <h2>{children}</h2>,
            h3: ({ children }) => <h3>{children}</h3>,
            p: ({ children }) => <p>{children}</p>,
            code: ({ children, className }) => {
              if (className) {
                return (
                  <pre>
                    <code className="block">{children}</code>
                  </pre>
                );
              }
              return <code>{children}</code>;
            },
            a: ({ children, href }) => (
              <a href={href} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            ),
            ul: ({ children }) => <ul>{children}</ul>,
            ol: ({ children }) => <ol>{children}</ol>,
            li: ({ children }) => <li>{children}</li>,
            strong: ({ children }) => <strong>{children}</strong>,
            em: ({ children }) => <em>{children}</em>
          }}
        >
          {message}
        </ReactMarkdown>
      </div>
    </div>
  </div>
);
